import { useTranslate } from '@ur-solutions/react-hooks'
import type { ApprovalRestPeriodNode } from '../../types.graphql'

/** `64:30`, not `2 days 16 hours`: a rest is read against the clock times beside it. */
export function formatRestDuration(start: Date, end: Date): string {
  const minutes = Math.max(
    0,
    Math.round((end.getTime() - start.getTime()) / 60000)
  )
  const hours = Math.floor(minutes / 60)
  return `${hours}:${String(minutes % 60).padStart(2, '0')}`
}

export function useRestLabels() {
  return useTranslate({
    dayRest: 'common.day-rest',
    weekRest: 'common.week-rest',
    reducedWeekRest: 'salary.reduced-week-rest',
  })
}

export function restTypeLabel(
  restType: ApprovalRestPeriodNode['restType'],
  labels: ReturnType<typeof useRestLabels>
): string {
  if (restType === 'WEEKLY') return labels.weekRest
  if (restType === 'REDUCED_WEEKLY') return labels.reducedWeekRest
  return labels.dayRest
}

/**
 * How many days' compensation a rest can be worth at most.
 *
 * A work day awards at most one diet, so the prompts cap there. An away-trip
 * is worth one per night it covers, and without raising that cap the field
 * cannot express the thing the feature exists for.
 */
export function restNights(start: Date, end: Date): number {
  const days = (end.getTime() - start.getTime()) / 86400000
  return Math.max(1, Math.ceil(days))
}
